const accountManagementStrings = {
  loginForm: {
    userInformationFormTitle: 'Welcome Back!',
    userInformationFormSubTitle: 'Login to continue',
    userInformationFormPhoneFieldPlaceholder: 'Mobile Number (01xxxxxxxxx)',
    userInformationFormPhoneFieldLabel: 'Mobile Number',
    userInformationFormNameFieldPlaceholder: 'Full Name',
    userInformationFormSubmitBtn: 'LOGIN',
    userInformationFormSignUpBtn: 'SIGN UP',
    userOtpFormTitle: 'Verify your mobile number',
    userOtpFormSubTitle: 'Verification code sent to',
    userOtpFormChangePhoneBtn: 'Change',
    userOtpFormChangePhoneText: "Didn't receive the code?",
    userOtpFormSendAgainBtn: 'Send it again',
    userOtpFormSendAgainText: "you'll receive the code in",
    userOtpFormSubmitBtn: 'Verify',
    userOtpFormDisclaimerText:
      "You'll be registered with a new account if you're not already registered.",
    userOtpFormTermsText: 'Terms and conditions apply',
    userInformationFormFieldErrorText(fieldName) {
      return `${fieldName} field must have a valid value`;
    },
    userAccessError: "You don't have permission for access",
    userOtpFormWrongOtpError: 'Wrong code entered, please try again',
  },

  signUpForm: {
    userInformationFormTitle: 'Sign Up',
    userInformationFormSubTitle: 'Enter your information',
    userInformationFormSubmitBtn: 'SIGN UP',
  },
};

export default accountManagementStrings;
